module.exports = __webpack_public_path__ + "img/lock.825522ce.svg";